// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#phlebio-view .case-creation__card {\n  position: relative;\n}\n#phlebio-view .case-creation__card .edit-btn {\n  position: absolute;\n  right: 0px;\n  top: -3px;\n  z-index: 99;\n  padding: 0 20px;\n  border: none;\n  background-color: transparent;\n  color: #828282;\n}\n#phlebio-view .case-creation__card .edit-btn img {\n  position: relative;\n  top: 2.5px;\n}\n#phlebio-view .case-creation__input .el-input__inner {\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
